import { render } from "./NewAcc.vue?vue&type=template&id=27db953f"
import script from "./NewAcc.vue?vue&type=script&lang=js"
export * from "./NewAcc.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__